import { useState } from "react"
import { mutate } from "swr"
import { DeliveryRouteApi } from "../../../apis"

interface EditPayload {
  routeId: string
  driverId: string
  vehicleId: string
  // Bэлдэх ажилтан (pull sheet staff). Single primary picker for now;
  // the backend also accepts an array if multiple pickers per route are
  // needed in the future.
  pullSheetStaffId?: string | null
}

export interface AssignmentResult {
  /** Pull-sheet IDs that were auto-created for the route's eligible DNs.
   *  Empty when no picker was assigned, or when all DNs already had one. */
  createdPullSheetIds: string[]
  /** Per-warehouse reasons returned by the backend when some DNs were
   *  skipped (e.g. still DRAFT, mixed drivers). Surfaced so callers can
   *  decide how loud to be about partial success. */
  skippedReasons: string[]
}

export function useEditRouteAssignment() {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const submit = async ({
    routeId,
    driverId,
    vehicleId,
    pullSheetStaffId,
  }: EditPayload): Promise<AssignmentResult> => {
    setSubmitting(true)
    setError(null)
    try {
      await DeliveryRouteApi.updateAssignment(routeId, {
        driverId,
        vehicleId,
      })

      // Бэлдэх ажилтан тохируулсан бол pull-sheet staff endpoint-ийг
      // дуудна — энэ нь route-ийн eligible DN-үүдэд PullSheet
      // автоматаар үүсгэж, "Ачилт удирдлага" хэсэгт харагдах болно.
      let createdPullSheetIds: string[] = []
      let skippedReasons: string[] = []
      if (pullSheetStaffId) {
        const ps = await DeliveryRouteApi.pullSheetStaff(routeId, {
          pullSheetStaffId,
        })
        createdPullSheetIds = ps.pullSheets ?? []
        skippedReasons = ps.skippedReasons ?? []
      }

      await mutate(
        (key) => Array.isArray(key) && key[0] === "delivery-routes",
        undefined,
        { revalidate: true },
      )
      await mutate(
        (key) => Array.isArray(key) && key[0] === "delivery-routes.list",
        undefined,
        { revalidate: true },
      )
      return { createdPullSheetIds, skippedReasons }
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err))
      setError(e)
      throw e
    } finally {
      setSubmitting(false)
    }
  }

  return { submit, submitting, error }
}
